import { render, staticRenderFns } from "./ProjectTranslations.vue?vue&type=template&id=69a6eec2&scoped=true&"
import script from "./ProjectTranslations.vue?vue&type=script&lang=js&"
export * from "./ProjectTranslations.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTranslations.vue?vue&type=style&index=0&id=69a6eec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a6eec2",
  null
  
)

export default component.exports